import axios from 'axios';
import ApiResponseHandler from "../handler/ApiResponseHandler";
import {satGlobals} from "../../../../../sat/helper/sat-globals";
import {JOB_STATE_FAILED, JOB_STATE_INCOMPLETE} from "../const/job.const";

class ApiManager {

    constructor() {
    }

    async create(payload = {}) {
        let apiJob = null;

        try {
            payload.async = true;
            apiJob = await axios.post(this._getUrl('api/jobs'), payload, {withCredentials: true});
            await this._waitUntilReady(apiJob.data);
            apiJob = await this.get(apiJob.data, true);
        } catch (err) {
            if (err.response) {
                ApiResponseHandler.handle(err.response);
            }
            return null;
        }

        return apiJob;
    }

    async delete(jobId) {
        await axios.post(this._getUrl(`api/jobs/${jobId}/delete`), {}, {withCredentials: true});
    }

    async shareAccessScope(jobId, payload) {
        await axios.post(this._getUrl(`api/jobs/${jobId}/share`), payload, {withCredentials: true});
    }

    async uploadBase64(job, file) {
        let config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
                'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
                'Access-Control-Allow-Credentials': true,
                'X-Oc-Token': job.token,
            },
            withCredentials: false,
        }

        let url = `${job.server}/upload-base64/${job.id}`
        let response = await axios.post(url, file, config);

        return response.data;
    }

    async start(job, payload) {
        let response;
        try {
            response = await axios.post(this._getUrl(`api/jobs/${job.id}/conversions`), payload, {withCredentials: true});
        } catch (err) {
            if (err.response) {
                ApiResponseHandler.handle(err.response);
            }

            return null;
        }

        return response.data;
    }

    async addInputs(job, payload) {
        let response;
        try {
            response = await axios.post(this._getUrl(`api/jobs/${job.id}/input`), payload, {withCredentials: true});
            await this._waitForInputs(job, payload);
        } catch (err) {
            if (err.response) {
                ApiResponseHandler.handle(err.response);
            }

            return null;
        }

        return response.data;
    }

    async get(job, async = false) {
        let response;

        let url = '';
        if (async === true) {
            job.id = job.sat.id_job;
            url = this._getUrl(`api/jobs/${job.sat.id_job}`) + '?async=true';
        } else {
            url = this._getUrl(`api/jobs/${job.id}`);
        }

        try {
            response = await axios.get(url, {withCredentials: true});
        } catch (err) {
            if (err.response) {
                ApiResponseHandler.handle(err.response);

                if (err.response.status === 404) {
                    return 404;
                }

                if (err.response.status === 401) {
                    return 401;
                }

                if (err.response.status === 402) {
                    return 402;
                }

                if (err.response.status === 403) {
                    return 403;
                }
            }

            return null;
        }

        return response.data;
    }

    _getUrl(endpoint) {
        return satGlobals.getApiUrl(endpoint);
    }

    async _waitForInputs(job, inputs, incomplete = 0) {
        let that = this;
        return new Promise((resolve, reject) => {

            async function _waitUntilComplete(job, incomplete = 0) {
                let apiJob = await that.get(job);

                if (null === apiJob) {
                    resolve();
                    return;
                }

                if (typeof inputs === 'object' && !Array.isArray(inputs) ) {
                    if (apiJob.input.length === 1) {
                        resolve();
                        return;
                    }
                } else {
                    if (apiJob.input.length === inputs.length) {
                        resolve();
                        return;
                    }
                }

                if (incomplete > 60) {
                    job.state = JOB_STATE_FAILED;

                    resolve();
                    return;
                }

                setTimeout(() => {
                    _waitUntilComplete(job, ++incomplete);
                }, 1000);
                return;
            }

            _waitUntilComplete(job, incomplete);
        });
    }

    async _waitUntilReady(job, incomplete = 0) {
        let that = this;
        return new Promise((resolve, reject) => {

            async function _waitUntilComplete(job, incomplete = 0) {
                let apiJob = await that.get(job, true);

                if (null === apiJob) {
                    resolve();
                    return;
                }

                if (apiJob.status.code === JOB_STATE_INCOMPLETE) {
                    resolve();
                    return;
                }

                if (apiJob.status.code !== JOB_STATE_INCOMPLETE) {
                    if (incomplete > 60) {
                        job.state = JOB_STATE_FAILED;

                        resolve();
                        return;
                    }

                    setTimeout(() => {
                        _waitUntilComplete(job, ++incomplete);
                    }, 500);
                    return;
                }

                setTimeout(() => {
                    _waitUntilComplete(job);
                }, 500);

                return;
            }

            _waitUntilComplete(job, incomplete);
        })
    }
}

export default new ApiManager()